import { KlevuRecord } from '@klevu/core';

export const sendRecommendationViewEvent = async (
  eventType: 'view_recs_list',
  currentProductId: string,
  recommendedProducts: KlevuRecord[]
) => {
  const recommendationViewEvent: RecommendationEvent = {
    event: eventType,
    event_apikey: window._KlevuConfig.apiKey,
    event_list_id: `similar-products-${currentProductId}`,
    event_list_name: 'Similar products',
    event_list_logic: 'SIMILAR_PRODUCTS',
    items: recommendedProducts.map((product, index) => ({
      item_id: product.id,
      item_group_id: product.itemGroupId,
      item_variant_id: product.id,
      item_name: product.displaytitle,
      price: product.price,
      currency: product.currency,
      item_brand: product.brand,
      item_category: product.klevu_category,
      index: index + 1,
    })),
  };

  try {
    await fetch('https://stats.ksearchnet.com/analytics/collect', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify([recommendationViewEvent]),
    });
  } catch {
    // Analytics are non-critical; silently ignore network failures
  }
};

export const sendRecommendationClickEvent = async (
  eventType: 'select_recs_list',
  product: KlevuRecord,
  position: number
) => {
  const recommendationClickEvent: RecommendationEvent = {
    event: eventType,
    event_apikey: window._KlevuConfig.apiKey,
    event_list_id: `similar-products-${product.id}`,
    event_list_name: 'Similar products',
    event_list_logic: 'SIMILAR_PRODUCTS',
    items: [
      {
        item_id: product.id,
        item_group_id: product.itemGroupId,
        item_variant_id: product.id,
        item_name: product.displaytitle,
        price: product.price,
        currency: product.currency,
        item_brand: product.brand,
        item_category: product.klevu_category,
        index: position,
      },
    ],
  };

  try {
    await fetch('https://stats.ksearchnet.com/analytics/collect', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify([recommendationClickEvent]),
    });
  } catch {
    // Analytics are non-critical; silently ignore network failures
  }
};

interface RecommendationEvent {
  event: string;
  event_apikey: string;
  event_list_id: string;
  event_list_name: string;
  event_list_logic: string;
  items: Product[];
}

interface Product {
  item_id: string;
  item_group_id: string;
  item_variant_id: string;
  item_name: string;
  price: string;
  currency: string;
  item_brand: string;
  item_category: string;
  index: number;
}
